import { CheckIcon } from '@components'
import cn from '@integrations/classnames'
import { tr } from 'mmfintech-commons'

import styles from './AuthShowcase.module.scss'

function getFeatures() {
  return [
    {
      title: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_1_TITLE', 'Instant notifications'),
      text: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_1_TEXT', 'Know the moment a payment or collection lands.')
    },
    {
      title: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_2_TITLE', 'Instant settlement'),
      text: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_2_TEXT', 'Funds reach your account right away.')
    },
    {
      title: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_3_TITLE', 'Payouts and refunds'),
      text: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_3_TEXT', 'Send money straight back to customers’ bank accounts.')
    },
    {
      title: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_4_TITLE', 'Advanced payer verification'),
      text: tr('FRONTEND.AUTH.SHOWCASE.FEATURE_4_TEXT', 'Built on banks’ own KYC checks to cut fraud risk.')
    }
  ]
}

function AuthShowcase() {
  return (
    <aside className={cn(styles['auth-showcase'], 'auth-showcase')}>
      <div className={cn(styles['auth-showcase-art'], 'auth-showcase-art')} aria-hidden='true'>
        <div className={cn(styles['auth-showcase-photo'], 'auth-showcase-photo')} />
        <div className={cn(styles['auth-showcase-toast'], 'auth-showcase-toast')}>
          <span className={cn(styles['auth-showcase-toast-icon'], 'auth-showcase-toast-icon')}>
            <CheckIcon size={18} strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
          </span>
          <span>
            <span className={cn(styles['auth-showcase-toast-label'], 'auth-showcase-toast-label')}>
              {tr('FRONTEND.AUTH.SHOWCASE.PAYMENT_RECEIVED', 'Payment received')}
            </span>
            <span className={cn(styles['auth-showcase-toast-amount'], 'auth-showcase-toast-amount')}>+ €970.00</span>
          </span>
        </div>
      </div>

      <div className={cn(styles['auth-showcase-content'], 'auth-showcase-content')}>
        <p className={cn(styles['auth-showcase-eyebrow'], 'auth-showcase-eyebrow')}>
          {tr('FRONTEND.AUTH.SHOWCASE.EYEBROW', 'Merchants')}
        </p>
        <h2 className={cn(styles['auth-showcase-title'], 'auth-showcase-title')}>
          {tr('FRONTEND.AUTH.SHOWCASE.TITLE', 'Get paid with Banky')}
        </h2>
        <p className={cn(styles['auth-showcase-lead'], 'auth-showcase-lead')}>
          {tr(
            'FRONTEND.AUTH.SHOWCASE.LEAD',
            "Fast, secure and seamless payments. Receive and collect funds directly in your company's account or a Banky merchant account."
          )}
        </p>

        <ol className={cn(styles['auth-showcase-features'], 'auth-showcase-features')}>
          {getFeatures().map(({ title, text }, index) => (
            <li key={title} className={cn(styles['auth-showcase-feature'], 'auth-showcase-feature')}>
              <span className={cn(styles['auth-showcase-feature-index'], 'auth-showcase-feature-index')}>
                {index + 1}
              </span>
              <span>
                <span className={cn(styles['auth-showcase-feature-title'], 'auth-showcase-feature-title')}>
                  {title}
                </span>
                <span className={cn(styles['auth-showcase-feature-text'], 'auth-showcase-feature-text')}>{text}</span>
              </span>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  )
}

export default AuthShowcase
